/* eslint-disable camelcase */
import React from 'react';
import CloudinaryUploadWidget from './CloudinaryUploadWidget';

const UploadImage = ({ setImages }) => {
  const handleOpenWidget = (file) => {
    const { secure_url, public_id } = file;
    setImages((prev) => [...prev, { url: secure_url, public_id }]);
  };

  return (
    <CloudinaryUploadWidget handleOpenWidget={handleOpenWidget} />
  );
};

export default UploadImage;
